import React, { useEffect } from 'react';
import './about.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
export default function About() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
    <div><Navbar/></div>
    <div class="container">
  
  <section class="header-section">
    <h1>Welcome to Sri Hari Home Care</h1>
    <p>Your Trusted Partner in Home Appliance Services</p>
  </section>


  <section class="about-section">
    <h2>About Us</h2>
    <p>Welcome to Sri Hari Home Care, your trusted home appliance service center. With over six years of successful service in the industry, we specialize in the repair and maintenance of washing machines, air conditioners, and refrigerators. Our commitment to transparency and quality work has earned us a reputation as a reliable and trusted community partner. We understand how crucial these appliances are to your daily life, and we strive to provide fast, efficient, and long-lasting solutions that ensure your home runs smoothly.</p>
    <p>Our team of expert technicians is dedicated to delivering top-notch services with clear, honest pricing. We believe in building long-term relationships with our customers through integrity, reliability, and professional excellence. From diagnostics to repair, we ensure each step of the process is handled with precision and care, so you can have complete peace of mind.</p>
  </section>

 
  <section class="services-section">
    <div class="service-card">
      <h3>Washing Machine Service</h3>
      <p>We provide comprehensive washing machine repair and maintenance services for all models, including front-load, top-load, and semi-automatic machines. Our experts use genuine parts and advanced tools to ensure your washing machine is restored to optimal performance.</p>
    </div>
    <div class="service-card">
      <h3>AC Service</h3>
      <p>Beat the heat with our reliable AC repair and maintenance services. From split systems to window units, our experienced technicians handle all types of air conditioners, ensuring efficient cooling and smooth operation all year round.</p>
    </div>
    <div class="service-card">
      <h3>Fridge Service</h3>
      <p>Our fridge repair services cover a wide range of issues, ensuring that your refrigerator functions perfectly. Whether it’s cooling problems, unusual noises, or leaks, our team has the expertise to get your fridge back in top shape.</p>
    </div>
  </section>

  
  <section class="mission-section">
    <h2>Our Mission</h2>
    <p>At Sri Hari Home Care, our mission is to provide top-quality appliance repair and maintenance services with honesty, reliability, and professionalism. We are dedicated to ensuring our customers’ satisfaction by delivering efficient, affordable solutions that you can rely on. Our goal is to keep your home comfortable and your appliances performing at their best, so you can enjoy peace of mind and convenience every day.</p>
  </section>

  
  <section class="contact-section">
    <h2>Contact Us</h2>
    <p>If you’re experiencing issues with your washing machine, air conditioner, or fridge, don’t hesitate to reach out. Our team is here to provide you with prompt, reliable service that meets your needs.</p>
    <a href="contact.html" class="contact-btn">Get in Touch</a>
  </section>
</div>

    <div><Footer/></div>
    </>
  )
}
